import { render, staticRenderFns } from "./reduction-word.vue?vue&type=template&id=4bd9ac32&"
import script from "./reduction-word.vue?vue&type=script&lang=js&"
export * from "./reduction-word.vue?vue&type=script&lang=js&"
import style0 from "./reduction-word.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports